module.exports = __webpack_public_path__ + "static/media/optimizely.92a02271.png";